/**
 * **getElement**_(element)_<br>
 * Helper to get element. If not passed in, uses the window object.
 * @param { Object } element: The element return. Defaults to window.
 * @returns { Node } The element.
 */
export const getElement = (element) => element || window;

/**
 * **addEventListener**_(e, callback, element)_<br>
 * Adds an event listener to an element.
 * @param { String } e: The event to add listener to.
 * @param { Function } callback: The function to run when event id triggered.
 * @param { Node } element: The element to add listener to. Defaults to window.
 * @returns { void }
 */
export const addEventListener = (e, callback, element) => {
  const el = getElement(element);
  if (el && el.addEventListener) {
    el.addEventListener(e, callback);
  }
};

/**
 * **removeEventListener**_(e, callback, element)_<br>
 * Removes an event listener from an element.
 * @param { String } e: The event to remove listener from.
 * @param { Function } callback: The function to remove.
 * @param { Node } element: The element to remove listener from.
 * @returns { void }
 */
export const removeEventListener = (e, callback, element) => {
  const el = getElement(element);
  if (el && callback && el.removeEventListener) {
    el.removeEventListener(e, callback);
  }
};
